import config from '../config'

export class ProductRequestHelper {
  static buildQueryParams(
    category,
    page,
    sort,
    refinements,
    queryParams,
    categoryResponse = {},
    templateType = null,
    isClearance = false
  ) {
    if (category) {
      if (this.isCategoryMultiselect(categoryResponse)) {
        queryParams = this.getMultiselectCategories(categoryResponse.attributes.pimid, queryParams)
      } else {
        queryParams['filter[category]'] = category
      }
    }
    if (isClearance) {
      queryParams['filter[clearance]'] = `${isClearance}`
    }
    if (page) {
      queryParams.page = page
    }
    queryParams.templateType = templateType

    const sortValue = this.getSort(sort)

    if (sortValue) {
      queryParams[`sort[${sortValue.type}]`] = sortValue.order
    }

    queryParams = { ...queryParams, ...this.getRefinements(refinements) }

    return queryParams
  }

  static getMultiselectCategories(pimIds = [], queryParams) {
    pimIds.forEach((id, i) => {
      i === 0 ? (queryParams['filter[category]'] = id) : (queryParams['filter[category]'] += `&filter[category]=${id}`)
    })

    return queryParams
  }

  static isCategoryMultiselect(categoryResponse) {
    return (
      !!categoryResponse &&
      !!categoryResponse.attributes &&
      !!categoryResponse.attributes.pimid &&
      categoryResponse.attributes.pimid.length > 0
    )
  }

  static getRefinements(refinements) {
    if (!refinements || !Object.keys(refinements).length) {
      return {}
    }

    return refinements.reduce((params, refinement) => {
      const { type, value } = refinement
      params[`filter[${type}]`] = value
      return params
    }, [])
  }

  static getSort(sort) {
    const sortByValues = config.searchSortByValues
    const selectedSortBy = sortByValues.find(sortBy => sortBy.path === `sort:${sort}`)

    return selectedSortBy ? selectedSortBy.value : null
  }
}
